import { MenuItem, MenuItems } from 'types.ts';
import ListIcon from '@mui/icons-material/List';
import HomeIcon from '@mui/icons-material/Home';

const workspace: MenuItem = {
  id: 'workspace-group',
  title: 'Workspace',
  type: 'group',
  children: [
    {
      id: 'home',
      title: 'Home',
      type: 'item',
      url: '/',
      icon: HomeIcon,
      breadcrumbs: false,
    },
    {
      id: 'projects',
      title: 'Projects',
      type: 'item',
      url: '/projects',
      icon: ListIcon,
      breadcrumbs: false,
    },
  ],
};

const menuItems: MenuItems = {
  items: [workspace],
};

export default menuItems;
